<template>
  <div class="content-page">
    <div class="bd">
      <div class="tab-header">
        <div class="top">
          <div class="top-item">
            <span>筛选条件</span>
            <el-input
              placeholder="电话或订单号"
              v-model.trim="orderCondition"
              clearable
              size="small"
            ></el-input>
          </div>
          <!-- <div class="top-item" v-if="currentPage != '/order/takeout'">
            <span>堂食桌位</span>
            <el-select
              v-model="tablePositionValue"
              placeholder="请选择"
              size="small"
            >
              <el-option
                v-for="item in tablePositionList"
                :key="item.shoppingTableId"
                :label="item.tableName"
                :value="item.shoppingTableId"
              >
                <span
                  style="float: left;width:60px;overflow:hidden;text-overflow:ellipsis;"
                  >{{ item.tableName }}</span
                >
                <span style="float: right; color: #8492a6; font-size: 13px;">{{
                  item.tableType
                }}</span>
              </el-option>
            </el-select>
          </div> -->
          <div class="top-item">
            <span>时间选择</span>
            <el-date-picker
              v-model="orderTime"
              type="daterange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              align="right"
              size="small"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
          <div class="top-item">
            <el-button type="primary" size="small" @click="screenOrder">筛选</el-button>
            <el-button @click="resetScreenData" size="small">重置</el-button>
            <el-button type="success" @click="openCheckCode()" size="small"
              >核销</el-button
            >
          </div>
        </div>
      </div>
      <div class="tab-content">
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane
            v-for="item in orderClassifyList"
            :key="String(item.orderStatus)"
            :label="String(item.orderNum)"
            :name="String(item.orderStatus)"
          >
            <span slot="label">
              <span>{{ item.orderStatusName }}</span>
              <el-badge
                v-if="
                  item.orderNum &&
                  (item.orderStatus == -21 ||
                    item.orderStatus == 19 ||
                    item.orderStatus == 20 ||
                    item.orderStatus == 31)
                "
                :value="item.orderNum"
                class="item"
              ></el-badge>
            </span>
          </el-tab-pane>
        </el-tabs>
        <div class="list" v-loading="isLoad">
          <div class="order-list" v-if="orderList.length">
            <ul>
              <li v-for="(item, index) in orderList" :key="item.tradeNo">
                <div class="item">
                  <div class="list-header">
                    <span class="order-num">#{{ item.orderNum }}</span>
                    <span class="delivery-time">{{ item.deliveryTime }}</span>
                    <!-- <span class="suggest">建议12:19送达</span> -->
                    <span class="order-no">
                      订单号：{{ item.tradeNo }}
                      <input
                        style="position: absolute; top: 0; left: 0"
                        :value="item.tradeNo"
                        :class="`order-no${index}`"
                      />
                    </span>
                    <el-button type="text" @click="copyOrderNo(index)">复制</el-button>
                  </div>
                  <div class="list-container">
                    <div class="products">
                      <div
                        class="products-item"
                        v-for="(productItem, itemIndex) in item.products"
                        :key="itemIndex"
                      >
                        <div class="info">
                          <img :src="productItem.goodsImage" alt />
                          <div>
                            <p class="name" :title="productItem.goodsName">
                              {{ productItem.goodsName }}
                            </p>
                            <p
                              class="desc"
                              v-if="productItem.specDesc"
                              :title="productItem.specDesc"
                            >
                              （{{ productItem.specDesc }}）
                            </p>
                            <p class="price">
                              ￥{{ Number(productItem.retailPrice).toFixed(2) }}
                            </p>
                          </div>
                        </div>
                        <div class="num">
                          X{{ productItem.buyCount }}
                          <span
                            class="num-type"
                            :class="{
                              retreat: productItem.productSaleStatus == 1,
                              give: productItem.productSaleStatus == 4,
                            }"
                            v-if="
                              productItem.productSaleStatus == 1 ||
                              productItem.productSaleStatus == 4
                            "
                            >{{ productItem.productSaleStatus == 1 ? "退" : "赠"
                            }}{{ productItem.buyCount }}</span
                          >
                        </div>
                        <div class="price">
                          ￥{{ Number(productItem.totalRetailPrice).toFixed(2) }}
                        </div>
                        <!-- <div
                            class="action"
                            v-if="
                              item.orderCategory == 5 &&
                                item.orderStatus == 31 &&
                                productItem.productSaleStatus != 1 &&
                                productItem.productSaleStatus != 4
                            "
                          >
                            <el-dropdown
                              @command="
                                handleEdit(
                                  $event,
                                  index,
                                  productIndex,
                                  itemIndex
                                )
                              "
                            >
                              <span class="el-dropdown-link">
                                编辑
                                <i
                                  class="el-icon-arrow-down el-icon--right"
                                ></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item command="retreat"
                                  >退菜</el-dropdown-item
                                >
                                <el-dropdown-item command="give"
                                  >赠送</el-dropdown-item
                                >
                              </el-dropdown-menu>
                            </el-dropdown>
                          </div>
                          <div class="action" v-else></div> -->
                      </div>
                    </div>
                    <div class="time">
                      <div class="time-item">
                        <p>{{ timeTitleFormat(item.orderStatus) }}</p>
                        <p>{{ timeOrderFormat(item) }}</p>
                      </div>
                    </div>
                    <div class="info">
                      <div>
                        <p class="address">
                          {{ item.buyerName }} {{ item.buyerPhone }}
                          {{ item.buyerAddress }}
                        </p>
                      </div>
                      <!-- <div v-if="item.isPickUp == 1 && item.orderCategory == 3">
                        <p class="takeoutinfo">
                          自提时间：{{ item.deliveryTime }}
                        </p>
                        <p class="address">提货人手机：{{ item.buyerPhone }}</p>
                      </div>
                      <div v-if="item.isPickUp != 1 && item.orderCategory == 3">
                        <p class="takeoutinfo">
                          {{ item.buyerName }} {{ item.buyerPhone }}
                        </p>
                        <p class="address">
                          {{ item.buyerAddress }}
                        </p>
                      </div>
                      <p v-if="item.orderCategory != 3" class="tanginfo">
                        <span class="position" v-if="item.buyerAddress"
                          >{{ item.buyerAddress }}号桌</span
                        >
                        <span class="position" v-if="!item.buyerAddress"
                          >自助订单</span
                        >
                        <span class="meals-number" v-if="item.mealsNum"
                          >{{ item.mealsNum }}人用餐</span
                        >
                      </p> -->
                      <p class="mark">备注：{{ item.buyerMark }}</p>
                      <!-- <img
                        class="icon-img"
                        :src="
                          item.isPickUp == 1 && item.orderCategory == 3
                            ? pickupPic
                            : item.isPickUp != 1 && item.orderCategory == 3
                            ? takeoutPic
                            : tangPic
                        "
                        alt
                      /> -->
                    </div>
                    <div class="price">
                      <p>合计：￥{{ item.totalRetailPrice }}</p>
                      <p>
                        含餐盒费：￥{{ item.foodBoxPrice }}，配送费：￥{{
                          item.distributionPrice
                        }}
                      </p>
                      <p>整单折后价：￥{{ item.gainMoney }}</p>
                      <el-dropdown
                        @command="fullHandleEdit($event, index)"
                        v-if="
                          item.orderStatus == 31 ||
                          item.orderStatus == 10 ||
                          item.orderStatus == 40
                        "
                      >
                        <span class="el-dropdown-link">
                          修改价格
                          <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item
                            v-if="item.orderStatus == 31 || item.orderStatus == 10"
                            command="priceRevision"
                            >整单改价</el-dropdown-item
                          >
                          <el-dropdown-item
                            v-if="item.orderStatus == 31 || item.orderStatus == 10"
                            command="discount"
                            >整单打折</el-dropdown-item
                          >
                          <el-dropdown-item v-if="item.orderStatus == 40" command="refund"
                            >整单退款</el-dropdown-item
                          >
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                    <div class="action" v-if="orderType[item.orderStatus]">
                      <p :class="orderType[item.orderStatus].class">
                        {{ orderType[item.orderStatus].title }}
                      </p>
                      <el-button
                        size="small"
                        type="primary"
                        v-if="orderType[item.orderStatus].btn"
                        @click="
                          handleOrder(
                            item.mallOrderId,
                            item.orderStatus,
                            item.totalRetailPrice,
                            item.entryType
                          )
                        "
                        >{{ orderType[item.orderStatus].btn }}</el-button
                      >

                      <el-button
                        size="small"
                        type="primary"
                        class="create-btn"
                        plain
                        v-if="item.orderStatus == 20"
                        @click="createEleOrder(item)"
                        >发货</el-button
                      >
                      <!-- <el-link
                        class="status-btn"
                        v-if="item.eleStatus == 1 && item.orderStatus == 20"
                        :underline="false"
                        type="success"
                        >此单已发送</el-link
                      > -->
                      <!-- <el-link
                        class="status-btn"
                        v-if="item.eleStatus == 5 && item.sendType == 3"
                        :underline="false"
                        type="warning"
                        >蜂鸟已取消订单</el-link
                      > -->
                      <!-- <el-button
                        size="small"
                        type="primary"
                        v-if="item.orderStatus == -21"
                        @click="dFuc(item.mallOrderId, -50)"
                        >原路返回</el-button
                      > -->
                    </div>
                    <div class="print">
                      <el-button
                        size="small"
                        type="primary"
                        plain
                        @click="printOrder(index)"
                        >打印小票</el-button
                      >
                      <el-button
                        v-show="item.orderStatus >= 30 && isDsType"
                        class="check-logistics"
                        size="small"
                        type="primary"
                        plain
                        @click="getLogisticsInfo(item.mallOrderId)"
                        >查看物流</el-button
                      >
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <div v-else>
            <div class="list-none">
              <p>暂无更多数据</p>
            </div>
          </div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :page-size="pageSize"
            :current-page="pageNo"
            background
            layout="prev, pager, next, jumper"
            :total="pageCount"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog title="发货" :visible.sync="isShowDeliverGoodsPop" width="30%">
      <div class="dialog-body">
        <el-select
          placeholder="请选择快递公司"
          v-model="sendCompanyId"
          style="margin-bottom: 10px"
        >
          <el-option
            v-for="item in expressCompanyList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-input placeholder="请输入单号" v-model="oddNumbers"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDeliverGoodsPop = false">取 消</el-button>
        <el-button type="primary" @click="deliverGoodsConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="提示" :visible.sync="isShowDiscountPop" width="30%">
      <div class="dialog-body">
        <el-input
          placeholder="请输入折扣，如八折输入0.8"
          v-model="discount"
          @input="inputChangeLimitNum"
        ></el-input>
        <div class="tag-list">
          <div
            class="tag"
            :class="{
              sel: !!~tagSelList.indexOf(item.goodsCategoryId),
            }"
            v-for="item in tagList"
            :key="item.goodsCategoryId"
            @click="toggleSelType(item)"
          >
            {{ item.categoryName }}
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isShowDiscountPop = false">取 消</el-button>
        <el-button type="primary" @click="discountConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="物流信息"
      :visible.sync="isShowLogisticsInfo"
      width="496px"
      v-if="isShowLogisticsInfo"
    >
      <div class="logistics-dialog">
        <div class="logistics-header">
          <img class="icon" src="../assets/img/order/icon-ele.png" alt="" />
          <div class="info">
            <div class="name">
              快递公司：<strong>{{ logisticsInfo.expressInfo.name }}</strong>
            </div>
            <div class="phonenum">快递单号：{{ logisticsInfo.LogisticCode }}</div>
          </div>
        </div>
        <div class="logistics-body">
          <div class="el-steps-oem">
            <div
              class="el-step-oem active"
              v-for="(item, index) in logisticsInfo.Traces"
              :key="item.id"
            >
              <div class="index">{{ logisticsInfo.Traces.length - index }}</div>
              <div
                class="title"
                :class="{
                  active:
                    logisticsInfo.Traces.length - index == logisticsInfo.Traces.length,
                }"
              >
                {{ item.Remark }}
              </div>
              <div class="desc">
                {{ item.AcceptStation }}
              </div>
              <div class="time">{{ item.AcceptTime }}</div>
            </div>
          </div>
          <!-- <el-steps direction="vertical" :active="logisticsInfo.status.length">
            <el-step v-for="item in logisticsInfo.status" :key="item.id">
              <div slot="description">
                <div class="title">
                  {{ logisticsInfoText[item.orderStatus].title }}
                </div>
                <div class="desc">
                  {{ logisticsInfoText[item.orderStatus].desc }}
                </div>
                <div class="time">{{ item.modifyTime }}</div>
              </div>
            </el-step>
          </el-steps> -->
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="请扫描核销码"
      :visible.sync="isShowCheck"
      width="496px"
      :before-close="handleClose"
    >
      <div class="check-code">
        <span class="check-code-title">核销码</span>
        <el-input
          ref="checkCodeInput"
          v-model="checkCode"
          placeholder="请输入核销码"
          @keydown.native.tab.prevent
          @blur="focusCheckCodeInput"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserActivityOrderTotalNum,
  getUserActivityOrderList,
  getShopTables,
  getOrderNumsByStatus,
  operateOrder,
  handleOrder,
  printOrder,
  createReundOrder,
  getEdcShopGoodsCategorys,
  getEleOrderShipDetail,
  createEleOrder,
  getExpressCompany,
  sendDSOrder,
  orderExpress,
  postUpdateOrderStatusByGpOrder,
} from "@/api";
import { formatGoodsCategoryListForUI } from "@/utils/goodsCategory";
import {
  isSecondaryCategorySwitchOn,
  getSecondaryCategoryList,
  createBackCategory,
} from "@/utils/secondaryCategory";
import takeoutPic from "@/assets/img/order/icon-takeout.png";
import tangPic from "@/assets/img/order/icon-tang.png";
import md5 from "js-md5";
import { getLodop } from "@/utils/LodopFuncs.js";
import { mapState } from "vuex";
import { createScannerInput } from "@/utils/scannerInput";

let params = null;
let orderList = null;
import { commonFuc } from "@/mixins/commonFuc";

export default {
  mixins: [commonFuc],
  data() {
    return {
      checkCode: "",
      isShowCheck: false, // 显示核销弹框
      takeoutPic: takeoutPic,
      tangPic: tangPic,
      pickupPic: require("@/assets/img/order/icon-pickup.png"),
      orderCondition: "",
      orderConditionPlaceholder: "",
      orderClassifyListBefore: [],
      orderClassifyList: [],
      activeName: "all",
      pageCount: 0,
      tablePositionValue: "all",
      tablePositionList: [
        {
          shoppingTableId: "all",
          tableName: "全部桌位",
        },
      ],
      orderCategory: "",
      orderTime: [],
      startDate: "",
      endDate: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 89);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      pageNo: 1,
      pageSize: 5,
      orderList: [],
      isLoad: false,
      orderType: {
        10: {
          title: "待付款",
          class: "black",
          // btn: "确认买单",
        },
        // 19: {
        //   title: "待接单",
        //   class: "red",
        //   btn: "确认接单",
        // },
        20: {
          title: "待发货",
          class: "red",
        },
        30: {
          title: "待确认",
          class: "black",
        },
        // 31: {
        //   title: "待买单",
        //   class: "black",
        //   btn: "确认买单",
        // },
        35: {
          title: "待评论",
          class: "black",
        },
        40: {
          title: "已完成",
          class: "black",
          btn: "退款",
        },
        "-10": {
          title: "已关闭",
          class: "red",
        },
        "-20": {
          title: "已取消",
          class: "red",
        },
        "-21": {
          title: "申请退款",
          class: "red",
          btn: "退款",
        },
        "-50": {
          title: "退款",
          class: "black",
        },
      },
      isShowDiscountPop: false,
      discount: "",
      tagList: [],
      tagListLv1: [],
      tagSelList: [],
      //是否显示蜂鸟快递信息弹窗
      isShowLogisticsInfo: false,
      logisticsInfoText: {
        1: {
          title: "商家已接单",
          desc: "商家已接单，等待骑手接单",
        },
        2: {
          title: "骑士正在赶往店内取货",
          desc: "骑士正在赶往店内取货，请提前备好商品",
        },
        3: {
          title: "骑士正在送货",
          desc: "骑士正在努力赶往收货地点",
        },
        4: {
          title: "商品已送达，订单已完成",
          desc: "感谢您对码点餐的信任，期待再次光临",
        },
        5: {
          title: "骑手取消订单",
          desc: "骑手取消订单",
        },
        7: {
          title: "订单已过期",
          desc: "订单已过期",
        },
        8: {
          title: "指派单",
          desc: "指派单",
        },
        9: {
          title: "配送异常",
          desc: "配送异常，骑手返回途中",
        },
        10: {
          title: "骑士正在店内取货",
          desc: "骑士取货后，订单自动变成已发货状态",
        },
        1000: {
          title: "创建运单失败",
          desc: "创建运单失败",
        },
      },
      logisticsInfo: {
        eleInfo: {
          delivery_info: {
            delivery_name: "毛晓松", //骑手姓名
            delivery_phone: "13587435597", //骑手电话
            delivery_party: "", //运力类型(汉字)
            delivery_longitude: "", //骑手经度
            delivery_latitude: "", //骑手纬度
          },
        },
        status: [
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 14:15:24",
            createTime: "2020-06-05 14:15:24",
            isDelete: 0,
            orderStatus: 1, ////订单状态(待接单＝1 待取货＝2 配送中＝3 已完成＝4 已取消＝5 已过期＝7 指派单=8 妥投异常之物品返回中=9  已到店=10（蜂鸟需要） 妥投异常之物品返回完成=10 创建达达运单失败=1000
            id: 79,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
          {
            mallOrderId: 11141,
            modifyTime: "2020-06-05 13:21:18",
            createTime: "2020-06-05 13:21:18",
            isDelete: 0,
            orderStatus: 5, //
            id: 77,
            isEnable: 1,
          },
        ],
      },
      //发货相关
      isShowDeliverGoodsPop: false,
      oddNumbers: "",
      expressCompanyList: [],
      sendCompanyId: "",
      mallOrderId: "",
    };
  },
  watch: {
    activeName(status) {
      this.orderClassifyList.forEach((val) => {
        if (val.orderStatus == status) {
          this.pageCount = val.orderNum;
        }
      });
      this.pageNo = 1;
      this.getPageData();
    },
    currentPage(v) {
      this.activeName = "all";
      this.getPageData();
    },
    orderTime(val) {
      this.startDate = val ? new Date(val[0]).pattern("yyyy-MM-dd") : "";
      this.endDate = val ? new Date(val[1]).pattern("yyyy-MM-dd") : "";
    },
    orderCondition(val) {
      if (!val.length) {
        this.getPageData();
      }
    },
    isShowDiscountPop(val) {
      if (!val) {
        this.discount = "";
        orderList = null;
        params = null;
      }
    },
  },
  computed: {
    ...mapState({
      shopInfo: (state) => state.shopInfo,
    }),
    currentPage() {
      let path = this.$route.path;
      if (path == "/order/dsOrder") {
        this.orderCategory = 14;
      }
      if (path == "/order/takeout") {
        this.orderCategory = 3;
      }
      if (path == "/order/tang") {
        this.orderCategory = 5;
      }
      this.getOrderNumsByStatus();
      return path;
    },
  },
  mounted() {
    if (this.$route.params.tradeNo) {
      this.orderCondition = this.$route.params.tradeNo;
    }
    this.getShopTables();
    this.getPageData();
    this.getEdcShopGoodsCategorys();
    this.checkCodeScanner = createScannerInput({
      getValue: () => this.checkCode,
      setValue: (value) => {
        this.checkCode = value;
      },
      getInput: () => this.getCheckCodeInput(),
      onEnter: async () => {
        const res = await postUpdateOrderStatusByGpOrder({
          verificationCode: this.checkCode,
        });
        if (res.code == 0) {
          this.$message({
            type: "warning",
            message: res.msg,
          });
        } else if (res.code == 1) {
          this.$message({
            type: "success",
            message: "核销成功",
          });
        }
        this.checkCode = "";
      },
      readonlyOnScan: true,
      trapTab: true,
      submitOnEnterAlways: true,
    });
  },
  methods: {
    getCheckCodeInput() {
      if (
        this.$refs.checkCodeInput &&
        this.$refs.checkCodeInput.$refs &&
        this.$refs.checkCodeInput.$refs.input
      ) {
        return this.$refs.checkCodeInput.$refs.input;
      }
      return null;
    },
    focusCheckCodeInput() {
      if (!this.isShowCheck) {
        return;
      }
      this.$nextTick(() => {
        this.checkCodeScanner.focus();
      });
    },
    handleClose() {
      this.isShowCheck = false;
      this.checkCode = "";
      document.onkeydown = null;
      this.checkCodeScanner.reset();
    },
    // 打开核销弹框
    openCheckCode() {
      this.isShowCheck = true;
      this.checkCodeScanner.reset();
      this.focusCheckCodeInput();
      document.onkeydown = this.checkCodeScanner.handleKeydown;
    },
    getPageData() {
      this.getAllOrders();
      this.getExpressCompany();
      this.getOrderNumsByStatus();
    },
    getEdcShopGoodsCategorys() {
      getEdcShopGoodsCategorys({
        pageNo: this.pageNo,
        row: 9999,
      }).then((res) => {
        if (res.code == 1) {
          res.data = formatGoodsCategoryListForUI(res.data);
          this.tagListLv1 = JSON.parse(JSON.stringify(res.data));
          this.tagSelList = [];
          res.data.forEach((val) => {
            this.tagSelList.push(val.goodsCategoryId);
          });
          this.tagList = res.data;
        } else {
          this.tagList = [];
        }
      });
    },
    getOrderNumsByStatus(cb) {
      getOrderNumsByStatus({
        orderCategorys: this.orderCategory ? this.orderCategory : "3,5",
        orderCategory: this.orderCategory,
        startDate: this.startDate,
        endDate: this.endDate,
        shoppingTableId: this.tablePositionValue == "all" ? "" : this.tablePositionValue,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          this.orderClassifyListBefore = res.data;
          let path = this.$route.path;
          let list = [];
          let orderClassifyList = [];
          if (path == "/order/dsOrder") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              {
                orderStatusName: "未付款",
                orderNum: 0,
                orderStatus: 10,
              },
              // {
              //   orderStatusName: "待接单",
              //   orderNum: 0,
              //   orderStatus: 19,
              // },
              {
                orderStatusName: "待发货",
                orderNum: 0,
                orderStatus: 20,
              },
              {
                orderStatusName: "待确认",
                orderNum: 0,
                orderStatus: 30,
              },
              // {
              //   orderStatusName: "待买单",
              //   orderNum: 0,
              //   orderStatus: 31,
              // },
              {
                orderStatusName: "待评论",
                orderNum: 0,
                orderStatus: 35,
              },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
              {
                orderStatusName: "申请退款",
                orderNum: 0,
                orderStatus: -21,
              },
            ];
          } else if (path == "/order/takeout") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              {
                orderStatusName: "未付款",
                orderNum: 0,
                orderStatus: 10,
              },
              // {
              //   orderStatusName: "待接单",
              //   orderNum: 0,
              //   orderStatus: 19,
              // },
              {
                orderStatusName: "待发货",
                orderNum: 0,
                orderStatus: 20,
              },
              {
                orderStatusName: "待确认",
                orderNum: 0,
                orderStatus: 30,
              },
              {
                orderStatusName: "待评论",
                orderNum: 0,
                orderStatus: 35,
              },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
              {
                orderStatusName: "申请退款",
                orderNum: 0,
                orderStatus: -21,
              },
            ];
          } else if (path == "/order/tang") {
            orderClassifyList = [
              {
                orderStatusName: "全部订单",
                orderNum: 0,
                orderStatus: "all",
              },
              // {
              //   orderStatusName: "待接单",
              //   orderNum: 0,
              //   orderStatus: 19,
              // },
              // {
              //   orderStatusName: "待买单",
              //   orderNum: 0,
              //   orderStatus: 31,
              // },
              {
                orderStatusName: "已完成",
                orderNum: 0,
                orderStatus: 40,
              },
              {
                orderStatusName: "申请退款",
                orderNum: 0,
                orderStatus: -21,
              },
            ];
          }
          orderClassifyList.forEach((val) => {
            this.orderClassifyListBefore.forEach((subval) => {
              if (
                val.orderStatus == subval.orderStatus ||
                (subval.orderStatus == 0 && val.orderStatus == "all")
              ) {
                console.log(subval);
                val.orderNum = subval.orderNum;
              }
            });
            list.push(val);
          });
          list.forEach((val) => {
            if (val.orderStatus == this.activeName) {
              console.log(val);
              this.pageCount = val.orderNum;
            }
          });
          this.orderClassifyList = list;
        }
      });
    },
    getAllOrders() {
      this.isLoad = true;
      getUserActivityOrderTotalNum({
        pageNo: this.pageNo,
        row: this.pageSize,
        orderStatus: this.activeName == "all" ? "" : this.activeName,
        orderCategory: 16,
        startDate: this.startDate,
        endDate: this.endDate,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          this.pageCount = res.data;
        }
      });
      getUserActivityOrderList({
        pageNo: this.pageNo,
        row: this.pageSize,
        orderStatus: this.activeName == "all" ? "" : this.activeName,
        orderCategory: 16,
        startDate: this.startDate,
        endDate: this.endDate,
        keyWord: this.orderCondition,
      }).then((res) => {
        if (res.code == 1) {
          this.orderList = res.data;
        } else if (res.code == -1) {
          this.orderList = [];
        }
        this.isLoad = false;
      });
    },
    getShopTables() {
      getShopTables({
        row: 1000,
      }).then((res) => {
        if (res.code == 1) {
          this.tablePositionList.push(...res.data);
        }
      });
    },
    resetScreenData() {
      this.pageNo = 1;
      this.tablePositionValue = "all";
      this.orderTime = [];
      this.startDate = "";
      this.endDate = "";
      this.orderCondition = "";
      this.getPageData();
    },
    screenOrder() {
      this.pageNo = 1;
      this.getPageData();
    },
    tabsChange(val) {},
    searchTable() {},
    handleSizeChange() {},
    handleCurrentChange(val) {
      this.pageNo = val;
      this.getPageData();
    },
    handleEdit(e, index, productIndex, itemIndex) {
      //单个菜品的操作
      let params = {
        mallOrderId: this.orderList[index].mallOrderId,
      };
      params.products = JSON.parse(
        JSON.stringify(this.orderList[index].productsOem[productIndex][itemIndex])
      );
      this.$prompt(`请输入${e == "retreat" ? "退菜" : "赠菜"}数量`, "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /\d+/,
        inputErrorMessage: "必须输入数字",
        inputPlaceholder: "请输入操作数量",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue > 0) {
              done();
            } else {
              this.$notify({
                title: "提示",
                message: "数量必须大于0",
                type: "error",
                duration: 2000,
              });
            }
          } else {
            done();
          }
        },
      })
        .then(({ value }) => {
          params.products.buyCount = value;
          params.products.productSaleStatus = e == "retreat" ? 1 : 4;
          params.products = JSON.stringify([params.products]);
          this.operateOrder(params);
        })
        .catch(() => {});
    },
    fullHandleEdit(e, index) {
      //整单操作
      params = {
        mallOrderId: this.orderList[index].mallOrderId,
      };
      if (e == "refund") {
        this.$confirm("确认整单退款吗？", "整单退款", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            params.fullOperateType = 1;
            this.operateOrder(params);
          })
          .catch(() => {});
      }
      if (e == "discount") {
        this.isShowDiscountPop = true;
        orderList = this.orderList[index];
      }
      if (e == "priceRevision") {
        this.$prompt("", "整单改价", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPattern: /\d+/,
          inputErrorMessage: "必须输入数字",
          inputPlaceholder: "请输入修改后的价格",
        })
          .then(({ value }) => {
            params.fullOperateType = 3;
            params.customPrice = value;
            this.operateOrder(params);
          })
          .catch(() => {});
      }
    },
    toggleSelType(item) {
      if (item.goodsCategoryId == "__back__") {
        this.tagList = JSON.parse(JSON.stringify(this.tagListLv1));
        this.tagSelList = this.tagList.map((val) => val.goodsCategoryId);
        return;
      }
      if (
        isSecondaryCategorySwitchOn() &&
        item.goodsCategoryId &&
        Number(item.level) !== 2 &&
        !item.__isParentAll
      ) {
        return getSecondaryCategoryList(item.goodsCategoryId, 9999).then((res) => {
          if (res.code == 1 && res.data && res.data.length) {
            res.data = formatGoodsCategoryListForUI(res.data);
            this.tagList = [
              createBackCategory(),
              {
                categoryName: `${item.categoryName}(全部)`,
                goodsCategoryId: item.goodsCategoryId,
                __isParentAll: true,
              },
              ...res.data,
            ];
          }
          this.tagSelList = [item.goodsCategoryId];
        });
      }
      const id = item.goodsCategoryId;
      if (!!~this.tagSelList.indexOf(id)) {
        this.tagSelList.splice(this.tagSelList.indexOf(id), 1);
      } else {
        this.tagSelList.push(id);
      }
    },
    discountConfirm() {
      if (!this.discount) {
        return this.$notify({
          title: "提示",
          message: "请填写折扣",
          type: "error",
          duration: 1000,
        });
      }
      if (!this.tagSelList.length) {
        return this.$notify({
          title: "提示",
          message: "请至少选择一个分类",
          type: "error",
          duration: 1000,
        });
      }
      let customPrice = 0;
      orderList.products.forEach((val) => {
        if (
          !!~this.tagSelList.indexOf(val.goodsCategoryId) &&
          val.productSaleStatus != 1 &&
          val.productSaleStatus != 4
        ) {
          customPrice += val.retailPrice * val.buyCount * this.discount;
        } else {
          if (val.productSaleStatus != 1 && val.productSaleStatus != 4) {
            customPrice += val.retailPrice * val.buyCount;
          }
        }
      });
      params.fullOperateType = 3;
      params.customPrice = customPrice.toFixed(2);
      this.isShowDiscountPop = false;
      this.operateOrder(params);
    },
    inputChangeLimitNum() {
      this.discount = this.discount.replace(/[^\d.]/g, "");
      this.discount = this.discount.replace(/\.{2,}/g, ".");
      this.discount = this.discount.replace(/^\./g, "0.");
      this.discount = this.discount.replace(
        /^\d*\.\d*\./g,
        this.discount.substring(0, this.discount.length - 1)
      );
      this.discount = this.discount.replace(/^0[^\.]+/g, "0");
      this.discount = this.discount.replace(/^[2-9]/g, "");
      this.discount = this.discount.replace(/^1[.*]/g, "1");
      this.discount = this.discount.replace(/^1[0-9]/g, "1");
      this.discount = this.discount.replace(/^(\d+)\.(\d\d).*$/, "$1.$2");
    },
    handleOrder(mallOrderId, orderStatus, payMoney, entryType) {
      let nextOrderStatus = 0;
      if (orderStatus == 19) {
        nextOrderStatus = 20;
      }
      if (orderStatus == 20) {
        nextOrderStatus = 30;
      }
      if (orderStatus == 31) {
        nextOrderStatus = 40;
      }
      if (orderStatus == 10) {
        nextOrderStatus = 20;
      }
      console.log(orderStatus, entryType);
      if (orderStatus == 40 || orderStatus == -21) {
        nextOrderStatus = -50;
        if (entryType != 3 && entryType != 4) {
          this.$prompt("请输入密码", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            inputType: "password",
          }).then(({ value }) => {
            createReundOrder({
              managerPassWord: String(md5(value)).toUpperCase(),
              mallOrderId: mallOrderId,
            }).then((res) => {
              if (res.code == 1) {
                this.$notify({
                  title: "提示",
                  message: "退款成功",
                  type: "success",
                  duration: 1000,
                });
                this.getPageData();
              } else {
                this.$notify({
                  title: "提示",
                  message: res.msg,
                  type: "error",
                  duration: 2000,
                });
              }
            });
          });
          return;
        }
      }
      this.handleOrderFuc(mallOrderId, nextOrderStatus);
    },
    handleOrderFuc(mallOrderId, nextOrderStatus) {
      handleOrder({
        mallOrderId: mallOrderId,
        orderStatus: nextOrderStatus,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    operateOrder(params) {
      operateOrder(params).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "操作成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 2000,
          });
        }
      });
    },
    copyOrderNo(index) {
      var copyText = document.querySelector(`.order-no${index}`);
      copyText.select();
      document.execCommand("copy");
      this.$notify({
        title: "提示",
        message: "复制成功",
        type: "success",
        duration: 1000,
      });
    },
    printOrder(index) {
      let order = this.orderList[index];
      console.log(order);
      // printOrder({
      //   mallOrderId: order.mallOrderId,
      //   printStage: order.printStage,
      // });
      let basePath = "https://www.madiancan.com/";
      let templateHtml = `<!DOCTYPE html><html><head><meta charset='utf-8'/><style>html,body{height:100%;width:100%;margin:0;padding:0}*{box-sizing:border-box}.split-line{margin-bottom:20px}.split-line.line{width:25%;border-bottom:1px solid black;margin-top:-9px;display:inline-block;*display:block;*display:inline}.split-line.words{width:100%;display:inline-block;*display:block;*display:inline;text-align:center;font-size:15.5px}#form1{text-align:left;padding:20px;width:100%}.section{padding-bottom:8px;width:100%}.types{width:100%}.p{font-size:13.5px;margin:8px auto;width:100%}.large-text{font-size:15.5px;margin:10px auto}.phone{margin-left:15px}.payment span{float:right;margin-right:7%}.col-7{flex:5;width:50%;display:inline-block;*display:block;*display:inline;vertical-align:bottom;font-size:14px}.col-7 span {width: 100%;white-space: normal;}.col-1{flex:2;width:20%;display:inline-block;*display:block;*display:inline;text-align:right;font-size:14px}.col-2{flex:3;width:30%;display:inline-block;*display:block;*display:inline;text-align:right;font-size:14px}.items{margin:8px auto;font-size:13.5px;width:100%;font-size:0;display:flex;align-items:flex-start;flex-wrap:nowrap;white-space:nowrap}.list-header,.list-container{border-bottom:1px dotted black}.footer{margin-top:10px}.footer.row+.row{margin-top:20px}p{margin:0;line-height:24px}</style></head><body><div style='margin-left: -30px;'><form id='form1'><div class=''><p>订单编号：${
        order.tradeNo
      }</p><p>下单时间：${
        order.createTime
      }</p></div><div class='list-header'><div class='items'><div class='col-7'>商品名称（规格）</div><div class='col-2'>数量</div></div></div><div class="list-container">${order.products
        .map(
          (
            val
          ) => `<div class='types'><div class='items'><div class='col-7'><span>${val.goodsName}(${val.specDesc})</span></div><div class='col-2'>x${val.buyCount}</div></div></div>
  `
        )
        .join("")}</div><div class='footer'>${
        !order.isPickUp
          ? `<div class='row'><p>收货人:${order.buyerName}</p><p>手机号:${order.buyerPhone}</p><p>收货地址：${order.buyerAddress}</p></div>`
          : `<div class='row'><p>自提</p><p>提货人:${order.buyerName}</p><p>手机号:${order.buyerPhone}</p></div></div>`
      }</div></body></html>`;
      console.log(templateHtml);
      LODOP = getLodop();
      if (!LODOP) {
        if (confirm("打印机连接失败,查看解决方案？")) {
          window.location.href = basePath + "print/tip.html";
        } else {
          return;
        }
      }
      LODOP.PRINT_INIT("订单小票");
      LODOP.ADD_PRINT_HTM(0, 10, "100%", "100%", templateHtml);
      LODOP.SET_PRINT_COPIES(1); //设置打印份数
      LODOP.SET_PRINT_PAGESIZE(3, 58 * 10, 40, "");
      // LODOP.PREVIEW();
      LODOP.SET_PRINTER_INDEXA(LODOP.GET_PRINTER_NAME("-1"));
      LODOP.PRINT();
    },
    getLogisticsInfo(mallOrderId) {
      orderExpress({
        mallOrderId,
      }).then((res) => {
        if (res.code == 1) {
          this.logisticsInfo = res.data;
          this.isShowLogisticsInfo = true;
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    createEleOrder(item) {
      if (this.isDsType) {
        if (item.isPickUp && item.isPickUp == 1) {
          this.handleOrder(item.mallOrderId, item.orderStatus);
        } else {
          this.isShowDeliverGoodsPop = true;
          this.mallOrderId = item.mallOrderId;
        }
      } else {
        this.handleOrder(item.mallOrderId, 20, item.totalRetailPrice, item.entryType);
      }
      // createEleOrder({
      //   mallOrderId,
      // }).then((res) => {
      //   if (res.code == 1) {
      //     this.$notify({
      //       title: "提示",
      //       message: "发货成功",
      //       type: "success",
      //       duration: 1000,
      //     });
      //     this.getPageData();
      //   } else {
      //     this.$notify({
      //       title: "提示",
      //       message: res.msg,
      //       type: "error",
      //       duration: 1000,
      //     });
      //   }
      // });
    },
    deliverGoodsConfirm() {
      sendDSOrder({
        mallOrderId: this.mallOrderId,
        sendCompanyId: this.sendCompanyId,
        expressNo: this.oddNumbers,
      }).then((res) => {
        if (res.code == 1) {
          this.$notify({
            title: "提示",
            message: "发货成功",
            type: "success",
            duration: 1000,
          });
          this.getPageData();
        } else {
          this.$notify({
            title: "提示",
            message: res.msg,
            type: "error",
            duration: 1000,
          });
        }
        this.isShowDeliverGoodsPop = false;
        this.mallOrderId = "";
        this.sendCompanyId = "";
      });
    },
    timeTitleFormat(orderStatus) {
      if (orderStatus == 10) {
        return "下单时间";
      }
      if (orderStatus == 20) {
        return "支付时间";
      }
      if (orderStatus == 30) {
        return "发货时间";
      }
      if (orderStatus == 35 || orderStatus == 40) {
        return "确认时间";
      }
      if (orderStatus == -50) {
        return "退款时间";
      }
      return "";
    },
    timeOrderFormat(item) {
      if (item.orderStatus == 10 && item.createTime) {
        return item.createTime.split(".0")[0];
      }
      if (item.orderStatus == 20 && item.payTime) {
        return item.payTime.split(".0")[0];
      }
      if (item.orderStatus == 30 && item.sendTime) {
        return item.sendTime.split(".0")[0];
      }
      if (item.orderStatus == 35 || (item.orderStatus == 40 && item.confirmTime)) {
        return item.confirmTime.split(".0")[0];
      }
      if (item.orderStatus == -50 && item.refundTime) {
        return item.refundTime.split(".0")[0];
      }
      return "";
    },
    getExpressCompany() {
      getExpressCompany().then((res) => {
        if (res.code == 1) {
          this.expressCompanyList = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.content-page {
  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
  }

  .tab-header {
    .top {
      display: flex;

      .top-item {
        display: flex;
        flex: 1;
        align-items: center;
        margin-right: 66px;

        span {
          white-space: nowrap;
          margin-right: 10px;
          font-size: 12px;
          color: #333333;
          font-weight: bold;
        }

        .el-select {
          width: 100%;
        }
      }
    }
  }

  .tab-content {
    display: block;
    padding: 20px;

    .order-list {
      .item {
        border: 1px solid #eeeeee;
        margin-bottom: 20px;

        .list-header {
          background: #f8f8f8;
          height: 48px;
          line-height: 48px;
          padding-left: 18px;

          .order-num {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-right: 10px;
          }

          .delivery-time {
            font-size: 12px;
            color: #f57878;
            margin-right: 10px;
          }

          .suggest,
          .order-no {
            font-size: 12px;
            color: #666666;
          }

          .suggest {
            margin-right: 28px;
          }

          .order-no {
            margin-right: 10px;
          }
        }

        .list-container {
          display: flex;

          & > div {
            border-right: 1px solid #eee;

            &:last-child {
              border-right: 0;
            }
          }

          .products {
            flex: 3.63;

            & > div:last-of-type {
              & > .products-item:last-of-type {
                border-bottom: 0;
              }
            }

            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;

            & > div {
              width: 100%;
            }

            .products-item {
              display: flex;
              height: 70px;
              box-sizing: border-box;
              align-items: center;
              border-bottom: 1px solid #eee;

              &:last-child {
                border-bottom: 0;
              }

              .info {
                flex: 5.3;
                display: flex;
                align-items: center;

                img {
                  width: 50px;
                  height: 50px;
                  margin: 0 10px 0 18px;
                }

                .price {
                  font-size: 12px;
                  line-height: 26px;
                  color: #666666;
                }

                .name {
                  font-size: 12px;
                  line-height: 28px;
                  color: #333333;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }

                .desc {
                  font-size: 12px;
                  line-height: 16px;
                  color: #666;
                  font-weight: bold;
                  white-space: nowrap;
                  max-width: 130px;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }

              .num {
                flex: 1.46;
                font-size: 12px;
                color: #333333;
                font-weight: bold;

                .num-type {
                  display: inline-block;
                  border: 1px solid;
                  border-radius: 4px;
                  text-align: center;
                  font-size: 12px;
                  line-height: 22px;
                  box-sizing: border-box;
                  width: 36px;
                  height: 24px;

                  &.retreat {
                    border-color: #fde2e2;
                    background-color: #fef0f0;
                    color: #f57878;
                  }

                  &.give {
                    border-color: #faecd8;
                    background-color: #fdf6ec;
                    color: #e6a45d;
                  }
                }
              }

              .price {
                flex: 2.11;
                width: 130px;
                font-size: 12px;
                color: #666666;
              }

              .action {
                flex: 1.11;
              }
            }
          }

          .time {
            flex: 0.87;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .time-item {
              font-size: 12px;
              color: #999999;
              line-height: 22px;
            }
          }

          & > .info {
            position: relative;
            flex: 1.95;
            padding: 32px 10px 0 15px;
            font-size: 14px;
            line-height: 1;

            .takeoutinfo {
              margin-bottom: 14px;
            }

            .address {
              margin-bottom: 24px;
            }

            .tanginfo {
              color: #333333;

              .position {
                font-weight: bold;
              }

              margin-bottom: 20px;
            }

            .mark {
              color: #ee3030;
            }

            .icon-img {
              position: absolute;
              right: 10px;
              top: 10px;
            }
          }

          & > .price {
            flex: 1.58;
            text-align: center;
            padding-top: 31px;
            padding-bottom: 20px;
            line-height: 1;
            font-size: 14px;

            & > p:nth-of-type(1) {
              color: #333333;
              font-weight: bold;
              margin-bottom: 15px;
            }

            & > p:nth-of-type(2) {
              font-size: 12px;
              color: #999999;
              margin-bottom: 12px;
            }

            & > p:nth-of-type(3) {
              color: #ee3030;
              margin-bottom: 20px;
            }
          }

          .action {
            text-align: center;
            padding-top: 30px;
            padding-bottom: 20px;
            flex: 1;

            & > p:nth-of-type(1) {
              font-size: 14px;
              font-weight: bold;

              &.red {
                color: #ee3030;
              }

              &.black {
                color: #000;
              }
            }

            & > .el-button--primary {
              margin-top: 15px;
            }

            .el-button + .el-button {
              &.create-btn {
                display: block;
                margin-left: 0;
                margin: 10px auto 0;
              }

              margin-left: 2px;
            }

            .status-btn {
              display: block;
              margin-left: 0;
              margin: 10px auto 0;
            }
          }

          .print {
            text-align: center;
            padding-top: 20px;
            flex: 1;

            .check-logistics {
              display: block;
              margin: 10px auto 0;
            }
          }
        }
      }
    }

    .list-none {
      text-align: center;
      font-size: 14px;
      color: #999999;
      padding-top: 20px;
    }
  }

  .el-dialog {
    .el-select {
      width: 100%;
    }
  }

  .tag-list {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 0;

    .tag {
      width: 90px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      background: url(../assets/img/order/bg-unsel.png) no-repeat top left/ 100% 100%;
      margin: 10px 0;
      cursor: pointer;

      &.sel {
        background: url(../assets/img/order/bg-sel.png) no-repeat top left/ 100% 100%;
      }
    }
  }

  .logistics-dialog {
    .logistics-header {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      border-radius: 6px;
      background: #f6fbff;
      padding: 14px 10px;

      .icon {
        width: 46px;
        height: 46px;
        margin-right: 10px;
      }

      .info {
        font-size: 12px;
        color: #409eff;
        line-height: 1;

        .name {
          margin-bottom: 8px;

          .tag {
            display: inline-block;
            padding: 3px 6px;
            background: #409eff;
            border-radius: 20px;
            border-bottom-left-radius: 0;
            font-size: 12px;
            line-height: 1;
            color: #fff;
            margin-left: 6px;
          }
        }
      }
    }

    .logistics-body {
      min-height: 500px;
      max-height: 500px;
      overflow: auto;
      margin-top: 22px;

      .el-steps-oem {
        padding: 10px;

        .el-step-oem {
          position: relative;
          padding-left: 40px;
          padding-bottom: 34px;

          &.active {
            &:not(:last-child)::before {
              background: #409eff;
            }

            .index {
              border-color: #409eff;
              color: #409eff;
            }
          }

          &:not(:last-child)::before {
            position: absolute;
            content: "";
            top: 0;
            bottom: 0;
            left: 12px;
            width: 2px;
            background: #c0c4cc;
          }

          .index {
            position: absolute;
            border: 2px solid #c0c4cc;
            height: 24px;
            width: 24px;
            line-height: 24px;
            text-align: center;
            font-size: 14px;
            color: #c0c4cc;
            left: 0;
            top: -5px;
            border-radius: 50%;
            background: #fff;
            font-weight: bold;
          }

          .desc,
          .time {
            font-size: 12px;
            color: #666666;
          }

          .title {
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            position: relative;
            top: -5px;

            &.active {
              color: #409eff;
            }
          }
        }
      }
    }
  }
}
.check-code {
  display: flex;
  align-items: center;

  &-title {
    width: 50px;
    margin-right: 30px;
  }
}
</style>

<style lang="less">
.el-transfer-panel__item {
  display: block;
}

.el-select-dropdown {
  width: 150px;
}
</style>
